import _defineProperty from "/home/circleci/project/website/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { curry, flatMap, map, range } from 'lodash/fp';
/**
 * Multiplies rows in given array
 *
 * @param {number} amount - how many multiplications should be performed
 * @param {string} key - key which should be treated as an n index during multiplication
 * @param {object[]} input - array of objects for multiplication
 *
 * @returns {object[]} result - multiplited array of objects
 *
 * @example
 * const input = [{ slug: 'foo', bar: true }]
 * multiplyArray(2, 'slug', input)
 * // returns [
 * //   { slug: 'foo-0', bar: true },
 * //   { slug: 'foo-1', bar: true },
 * // ]
 */

export var multiplyArray = curry(function (amount, key, input) {
  return flatMap(function (record) {
    return map(function (index) {
      return _objectSpread(_objectSpread({}, record), {}, _defineProperty({}, key, "".concat(record[key], "-").concat(index)));
    }, range(0, amount));
  }, input);
});
export default multiplyArray;